// extracted by mini-css-extract-plugin
export default {"inputGroup":"EditUpload_inputGroup__4bzOg"};